import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { customerComplaintsData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function CustomerComplaintsPage() {
    return <SolutionTemplate {...customerComplaintsData} />;
}
